import { IndicatorPill } from "@codat/orchard-ui";
import { useEffect, useState } from "react";

import { CompanyStatusType, GetCompanyStatus } from "../../utilsCompanyStatus";
import {
  ConnectionStatusType,
  showConnectionStatus,
} from "../../utilsConnectorStatus";

interface Props {
  value: {
    syncStatus: CompanyStatusType;
    connectorStatus: ConnectionStatusType;
  };
}

const StatusPill: React.FC<Pick<Props, "value">> = ({ value }) => {
  const [syncStatus, setSyncStatus] = useState<{
    Color: string;
    Text: string;
    Description: string;
  }>({ Color: "", Text: "", Description: "" });

  const [connectionStatus, setConnectionStatus] = useState<
    ConnectionStatusType | ""
  >("");

  useEffect(() => {
    setSyncStatus(GetCompanyStatus(value.syncStatus));
    setConnectionStatus(value.connectorStatus);
  }, [value.syncStatus, value.connectorStatus]);

  const label = showConnectionStatus(connectionStatus) || syncStatus;

  return (
    <div title={`${label.Text}: ${label.Description}`}>
      <IndicatorPill label={label.Text} color={label.Color} />
    </div>
  );
};

export default StatusPill;
